import React from 'react';

class DutchieRegisterToggle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleCollapse: false,
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({ toggleCollapse: !this.state.toggleCollapse });
    }

    render() {
        return (
            <div className='toggle-container'>
                <div className='toggle-header'>
                    <img src='/assets/dutchie-logo.png' alt='Dutchie Logo' />
                    <button className='toggle-close-button' onClick={this.handleToggle}>
                        {!this.state.toggleCollapse ? (
                            <i className='fa fa-solid fa-chevron-down' />
                        ) : (
                            <i className='fa fa-solid fa-chevron-up' />
                        )}
                    </button>
                </div>
                <div className='toggle-caption'>
                    {this.props.toggleCopy.header}
                </div>
                {!this.state.toggleCollapse && (
                    <React.Fragment>
                        <div className='toggle-description-wrapper'>
                            {this.props.toggleCopy.description}
                        </div>
                        <button id='dutchieToggle' className='toggle-button' onClick={this.props.onClick}>
                            Enable Dutchie POS
                        </button>
                    </React.Fragment>
                )}
                {this.state.toggleCollapse && (
                    <React.Fragment>
                        <div className='toggle-body-wrapper'>
                            <span className='toggle-header-text'>Dutchie POS is here!</span>
                            <button id='dutchieToggle' className='toggle-button' onClick={this.props.onClick}>
                                Enable
                            </button>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default DutchieRegisterToggle;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/DutchieRegisterToggle.react.jsx